import type { FaireProductEntity } from "../../entity_types/product";

export const p_8urzwpzz2j: FaireProductEntity = {
  token: "p_8urzwpzz2j",
  type: "product",
  name: "fruit watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/059e0d69ec20f0d99a0fed3f58d838a874c5aa1ae0eccfec1568c2c0f52d6250.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90ba248cd51e4b8f844b42c541d049d3b1c2c5c351e3c1316b365c85910ab367.jpeg",
    "https://cdn.faire.com/fastly/899457c581b54aa773948ab0404743ddc7550003663fd9cf687912c7ad631e34.jpeg",
    "https://cdn.faire.com/fastly/5be1c829a4a1e53ff818b77916c256a8cf6c91888833b3872380c10fdbd7c5b1.jpeg",
    "https://cdn.faire.com/fastly/55e97654b9d7512937f3a2cb5c70d4d43c2da985f1406fa68d217e51c41a9ab4.jpeg",
    "https://cdn.faire.com/fastly/2ff84ef1a0490a3b52a1e5a493f2b09d8d928a147cda1fd9fe7fbb954bf50999.jpeg",
    "https://cdn.faire.com/fastly/f6e119f2f640399a87a273185339b04ecfc9e373181c9622b2dd8822659ddd99.jpeg",
    "https://cdn.faire.com/fastly/60b22e5f61ea555494e49deabef71fc5067151c503ee56147d2e350062c16fca.jpeg",
    "https://cdn.faire.com/fastly/f4e82aa5b829977ca2fc863b32529f30d5985205e9d8b45aa379c89e4fc0c936.jpeg",
    "https://cdn.faire.com/fastly/026490869bb86c0b966adb2bf8ea5764d428358c9e3c4813222a2866366d10d5.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve favorite fruits — strawberries, blueberries, lemons, cherries, apples, pears, grapes, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA bright, cheerful title that performs well in kitchen-focused and home boutiques. Strong year-round seller.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:07.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
